// extracted by mini-css-extract-plugin
export default {"wrapper":"GroupsStatusConfiglist_wrapper__bK4Tn"};